import { l } from '@js/utils/toolbox';

/**
 * Dialog class for displaying a dialog with accept or cancel options.
 * @class
 * @param {string} title - The title of the dialog.
 * @param {string} text - The text content of the dialog.
 * @param {Function} callback - The callback function to execute on accepting the dialog.
 * @param {Object} options - Optional configuration options for the dialog. At the moment 'singleButton' and 'cancelOnClickout' are the only options
 */
export class Dialog {
	constructor (title, text, callback, options = {}) {
		this.title = title;
		this.text = text;
		this.callback = callback;
		this.options = options;

		this.createDialog();
	}

	createDialog () {
		this.dialog = document.createElement('dialog');

		this.dialog.className = 'dialog hidden';

		const dialogContent = document.createElement('div');
		dialogContent.className = 'dialog-content';

		const dialogTitle = document.createElement('h1');
		dialogTitle.className = 'dialog-title';
		dialogTitle.innerText = this.title;

		const dialogText = document.createElement('p');
		dialogText.className = 'dialog-text';
		dialogText.innerText = this.text;

		const dialogFooter = document.createElement('div');
		dialogFooter.className = 'dialog-footer';

		if (!this.options?.singleButton) {
			const cancelButton = document.createElement('button');
			cancelButton.className = 'dialog-btn abBtn abBtn--flex abBtn--whiteBlue';
			cancelButton.innerText = l('global.simplePhrases.abort');
			cancelButton.addEventListener('click', this.cancel.bind(this));
			dialogFooter.appendChild(cancelButton);

			this.dialog.addEventListener('click', (event) => {
				if (!event.target.closest('.dialog-content')) {
					if (this.options.cancelOnClickout) {
						this.cancel();
					} else {
						this.accept();
					}
				}
			});
		} else {
			this.dialog.addEventListener('click', (event) => {
				if (!event.target.closest('.dialog-content')) {
					if (this.options.cancelOnClickout) {
						this.cancel();
					} else {
						this.accept();
					}
				}
			});
		}

		const acceptButton = document.createElement('button');
		acceptButton.className = 'dialog-btn abBtn abBtn--flex abBtn--blueWhite';
		acceptButton.innerText = l('global.simplePhrases.ok');
		acceptButton.addEventListener('click', this.accept.bind(this));
		dialogFooter.appendChild(acceptButton);

		dialogContent.appendChild(dialogTitle);
		dialogContent.appendChild(dialogText);

		if (this.options.additionalElements?.length) {
			for (const additionalElement of this.options.additionalElements) {
				dialogContent.append(additionalElement);
			}
		}

		dialogContent.appendChild(dialogFooter);

		this.dialog.appendChild(dialogContent);

		document.body.appendChild(this.dialog);
	}

	show () {
		document.body.classList.add('modal-open');
		this.dialog.showModal();
		this.dialog.classList.remove('hidden');
	}

	accept () {
		if (this.callback && typeof this.callback === 'function') {
			this.callback();
		}
		this.destroy();
	}

	cancel () {
		this.dialog.classList.add('hidden');
		setTimeout(this.destroy(), 300);
	}

	destroy () {
		document.body.classList.remove('modal-open');
		this.dialog.style.display = 'none';
		this.dialog.remove();
	}
}
